/* istanbul ignore file  */
export enum SitePageTooltipMessages {
    PushField = "The value in this field is being pushed to a Smartsheet connection.",
    PushFieldGrid = "Some columns are being pushed to a Smartsheet connection.",
    PullField = "This field is automatically updated based on a Smartsheet connection and cannot be manually edited.",
    SetField = "This field is automatically updated based on predefined rules and cannot be manually edited.",
    SetFieldGrid = "The following column(s) are automatically updated based on predefined rules and cannot be manually edited: "
}
